/**
 * Runtime configuration for usersAndProjects API client
 *
 * This configuration is applied when the client is imported.
 * Base URL and credentials are set based on the runtime config.
 *
 * This file is outside the usersAndProjects-client folder to prevent
 * it from being overwritten when regenerating the client.
 */

import { config as appConfig } from "@/config";
import type { CreateClientConfig } from "./usersAndProjects-client/client.gen";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: appConfig.usersAndProjects.url,
  credentials: "include",
});
